// A replay cannot reach Google, and nothing checks the token it never gets:
// its responses all come from the recording.
const GoogleRecaptchaReplayPort = {
  add: function (app) {
    app.ports.initializeRecaptchaPort.subscribe(function () {
      setTimeout(function () {
        app.ports.gotRecaptchaInitializedPort.send("Ok");
      }, 0);
    });

    app.ports.getRecaptchaTokenPort.subscribe(function () {
      app.ports.gotRecaptchaTokenPort.send({ token: "replay", result: "ok" });
    });
  },
};

module.exports = GoogleRecaptchaReplayPort;
